module.exports = __webpack_public_path__ + "img/gq18.dc2e3208.png";